// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 143 ? "ebec3a01" : chunkId) + "." + {"143":"421e752920a92fd3","938":"63f186b584528192"}[chunkId] + ".js";
};